import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/web3-game/share_game_ideas.webp";

function Streamlinecloud() {
  return (
    <section
      className="streamline_cloud blockchain_future"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={8} lg={8} xl={8} xxl={8}>
            <h2>
              Share your vision for the next groundbreaking{" "}
              <span>Web3 game and we’ll bring it to a revenue</span>-ready
              asset!
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book a call
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Streamlinecloud;
